<template>
  <div class="session">
    <div class="session-bg" aria-hidden="true"></div>

    <div class="session-card">
      <div class="session-ico">
        <svg class="sad" viewBox="0 0 120 120" role="img" aria-label="Üzgün">
          <defs>
            <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#1d4ed8" stop-opacity="0.95"/>
              <stop offset="1" stop-color="#0ea5e9" stop-opacity="0.95"/>
            </linearGradient>
          </defs>
          <circle cx="60" cy="60" r="44" fill="none" stroke="url(#g)" stroke-width="8"/>
          <circle cx="44" cy="52" r="6" fill="#0f172a"/>
          <circle cx="76" cy="52" r="6" fill="#0f172a"/>
          <path d="M42 86c7-10 29-10 36 0" fill="none" stroke="#0f172a" stroke-width="8" stroke-linecap="round"/>

        </svg>
      </div>

      <div class="session-title">Oturumunuz sona erdi</div>
      <div class="session-sub">
        Güvenliğiniz için oturum kapatıldı. Devam etmek için tekrar giriş yapabilirsiniz.
      </div>

      <div class="session-actions">
        <button class="session-btn" type="button" @click="$helper.logout">
          <span class="session-btn__ico" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M10 17l1.41-1.41L8.83 13H20v-2H8.83l2.58-2.59L10 7l-7 7 7 7z" fill="currentColor"/>
            </svg>
          </span>
          Güvenli Çıkış
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Oturum',
  created () {
    this.$store.setLoading([false, 'Bekleyiniz'])
  }
}
</script>

<style scoped>
.session{
  min-height: 100vh;
  display:flex;
  align-items:center;
  justify-content:center;
  padding: 18px 12px;
  position: relative;
  overflow:hidden;
  background: #f6f8ff;
}
.session-bg{
  position:absolute;
  inset:-120px;
  background:
    radial-gradient(900px 480px at 18% 10%, rgba(29,78,216,.16), transparent 58%),
    radial-gradient(700px 420px at 88% 22%, rgba(14,165,233,.12), transparent 58%),
    radial-gradient(900px 520px at 45% 96%, rgba(29,78,216,.10), transparent 60%);
  filter: blur(6px);
  opacity: 1;
}
.session-card{
  position: relative;
  z-index: 1;
  width: min(520px, 96vw);
  border-radius: 18px;
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(148,163,184,.35);
  box-shadow:
    0 18px 50px rgba(15,23,42,.10),
    0 2px 0 rgba(255,255,255,.8) inset;
  padding: 22px 18px 18px 18px;
}
.session-ico{
  width: 108px;
  height: 108px;
  border-radius: 26px;
  margin: 0 auto 12px auto;
  display:flex;
  align-items:center;
  justify-content:center;
  background: linear-gradient(135deg, rgba(29,78,216,.14), rgba(14,165,233,.08));
  border: 1px solid rgba(29,78,216,.18);
}
.sad{ width:86px; height:86px; display:block; }
.session-title{
  text-align:center;
  font-size: 22px;
  font-weight: 900;
  color:#0f172a;
  letter-spacing: .2px;
}
.session-sub{
  text-align:center;
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color:#475569;
}
.session-actions{
  margin-top: 18px;
  display:flex;
  flex-direction:column;
  gap: 10px;
}
.session-btn{
  height: 44px;
  border-radius: 12px;
  font-weight: 900;
  border: 1px solid rgba(29,78,216,.35);
  background: linear-gradient(135deg, rgba(29,78,216,.14), rgba(14,165,233,.10));
  color: #0f172a;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
  cursor:pointer;
  transition: transform .08s ease, box-shadow .12s ease, background .12s ease;
  box-shadow: 0 10px 22px rgba(15,23,42,.08);
}
.session-btn:hover{
  background: linear-gradient(135deg, rgba(29,78,216,.18), rgba(14,165,233,.12));
  box-shadow: 0 14px 28px rgba(15,23,42,.10);
}
.session-btn:active{
  transform: translateY(1px);
  box-shadow: 0 8px 18px rgba(15,23,42,.08);
}
.session-btn__ico{
  width:18px;
  height:18px;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  color:#1d4ed8;
}
.session-btn__ico svg{ width:18px; height:18px; display:block; }
</style>



// WEBPACK FOOTER //
// src/views/oturum.vue